import React, { useState } from 'react';

import { withRouter } from 'react-router-dom';

import { useGetRecord } from 'root/admin/components/hooks';
import { Title } from 'root/admin/components';

import store from 'root/admin/store';
import { Form, Field, Loader, ManyToManySelect } from '@smartplatform/ui';
import { useGetRecords } from '../../components/hooks';

const ArticleEdit = ({ match, rootPath }) => {
	const { id } = match.params;
	const options = { include: ['tags'] };
	const record = useGetRecord({ model: 'Link', id, options, tabName: 'links' });
	const [error, setError] = useState();

	if (record && !record.id) {
		record.mainPage = false;
		record.publishAt = new Date();
	}

	if (!record) {
		return <Loader />;
	}

	const onSave = () => {
		if (isNaN(id)) {
			console.log(store);
			store.history.push(`/admin/articles/articles/${record.id}`);
		} else {
			store.history.push('/admin/articles/articles');
		}

		return true;
	};

	const onDelete = async () => {
		try {
			// await record.delete();
			store.history.push('/admin/articles/articles');
		} catch (err) {
			console.log('record already deleted');
		}
	};

	return (
		<div>
			<Title record={record} name="Ссылки" />
			<Form record={record} rootPath={rootPath}>
				<Field property="name" label="Название" />
				<Field property="link" label="Ссылка" />

				<Field label="Метки">
					<ManyToManySelect
						relation="tags"
						computed={type => <span title={type.id}>{type.name}</span>}
						itemTag={type => <span title={type.id}>{type.name}</span>}
						searchFields={['name']}
						filter={{ where: { type: 'link' } }}
					/>
				</Field>
			</Form>
		</div>
	);
};

export default withRouter(ArticleEdit);
